<template>

    <vx-card id="dailyChannelChart" class="vs-con-loading__container">

        <template slot="actions">

            <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                <small class="flex cursor-pointer">
                    <span>{{metricTimes[timeRange]}}</span>
                    <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                </small>
                <vs-dropdown-menu class="w-48">
                    <vs-dropdown-item @click="timeRange = 1">Last day</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 7">Last 7 days</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 14">Last 14 days</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 30">Last 30 days</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 90">Last 90 days</vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

            <feather-icon icon="RefreshCwIcon" @click="loadData()"></feather-icon>

        </template>

        <vue-apex-charts v-if="chartOptions" type="line" height="600" :options="chartOptions" :series="chartData"/>

    </vx-card>
</template>
<script>

import VueApexCharts from 'vue-apexcharts'

export default {
    props: {
        link: {
            type: String,
            required: true
        }
    },
    components: {
        VueApexCharts
    },
    data(){
        return {

            chartData: [],
            timeRange: 7,

            metricTimes: {
                1: 'Last day',
                7: 'Last 7 days',
                14: 'Last 14 days',
                30: 'Last 30 days',
                90: 'Last 90 days'

            },

            chartOptions: {
                colors: ['#2ecc71', '#3498db', '#f1c40f', '#e74c3c', '#e67e22', '#9b59b6', '#34495e', '#1abc9c', '#95a5a6', '#c0392b', '#7f8c8d', '#27ae60', '#2980b9', '#16a085', '#f39c12', '#d35400', '#8e44ad', '#2c3e50'],
                xaxis: {
                    type: 'datetime',
                    labels: {
                        datetimeUTC: true
                    }
                },
                yaxis: {
                    min: 0,
                    forceNiceScale: true,
                    labels: {
                        formatter: function(value) {
                            return ((value) ? value : 0) + ' min'
                        }
                    }
                },
                tooltip: {
                    x: {
                        format: 'dd/MM/yyyy'
                    },
                    style: {
                        fontSize: '11px'
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'straight',
                    width: 3
                },
                title: {
                    text: 'Daily watch statistics',
                    align: 'left'
                }
            }

        }
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#dailyChannelChart',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this
            const loadPromise = this.$http.get(this.link + '?days=' + this.timeRange)
            loadPromise.then(function(response) {
                thisIns.chartData = JSON.parse(JSON.stringify(response.data))
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#dailyChannelChart > .con-vs-loading')
            })
        }
    },
    watch: {
        timeRange() {
            this.loadData()
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>
